import React from 'react';
import { Row, Col, Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { Container, Body, Header } from './styles';

interface CollapseCheckProps {
	value: boolean;
	disabled?: boolean;
	header: JSX.Element;
	onChange: () => void;
	children?: JSX.Element;
}

export const CollapseCheck: React.FC<CollapseCheckProps> = ({
	header,
	onChange,
	children,
	value = false,
	disabled = false
}) => {
	function handleChange(event: React.MouseEvent<HTMLDivElement, MouseEvent> | CheckboxChangeEvent): void {
		if (disabled) {
			return;
		}
		event.preventDefault();
		event.stopPropagation();
		onChange();
	}

	return (
		<Container
			onClick={(event) => {
				if (!value) {
					handleChange(event);
				}
			}}
			hasBody={!!children}
			disabled={disabled}
			selected={value}
			noPadding={true}
		>
			<Col
				onClick={handleChange}
				span={24}
				style={{
					cursor: disabled ? 'not-allowed' : 'pointer',
					paddingLeft: 15,
					paddingRight: 15,
					paddingTop: 15,
					paddingBottom: 15
				}}
			>
				<Row justify="start" align="middle" gutter={[24, 0]}>
					<Col xs={1}>
						<Checkbox
							style={{ alignItems: 'center' }}
							checked={value}
							onChange={handleChange}
							disabled={disabled}
						/>
					</Col>

					<Header className="collapse-check-custom" span={23} onClick={handleChange} selected={value}>
						{header}
					</Header>
				</Row>
			</Col>
			{children && value && (
				<Col span={24}>
					<Body open={value}>{children}</Body>
				</Col>
			)}
		</Container>
	);
};
